import React from 'react'
import injectSheet from 'react-jss'
import styles from './bulk-action.styles'
import { ActionButton } from 'pobble-components/dist/bulk-action'
import TrashIcon from 'react-icons/lib/fa/trash-o'
import CheckIcon from 'react-icons/lib/fa/check-circle-o'
import CircleIcon from 'react-icons/lib/fa/circle-o'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const BulkAction = ({ classes, onRemove, onMarkAsSeen, onMarkAsUnseen }) => (
  <ActionButton>
    {({ Menu, MenuItem, IconHolder, closePopover, bulkSelectedList }) => (
      <Menu>
        <MenuItem
          onClick={() => {
            closePopover()
            onMarkAsSeen(bulkSelectedList)
          }}>
          <IconHolder>
            <CheckIcon />
          </IconHolder>
          Mark as seen
        </MenuItem>
        <MenuItem
          onClick={() => {
            closePopover()
            onMarkAsUnseen(bulkSelectedList)
          }}>
          <IconHolder>
            <CircleIcon />
          </IconHolder>
          Mark as unseen
        </MenuItem>
        <MenuItem
          className={classes.archive}
          onClick={() => {
            closePopover()
            openConfirmationDialog({
              bodyText: `Are you sure you want to archive ${bulkSelectedList.length} invitations?`,
              action: () => onRemove(bulkSelectedList),
              confirmText: 'Archive',
              cancelText: 'Cancel'
            })
          }}>
          <IconHolder>
            <TrashIcon />
          </IconHolder>
          Archive
        </MenuItem>
      </Menu>
    )}
  </ActionButton>
)

export default injectSheet(styles)(BulkAction)
